<p class="margin-dialog-message">
    <i class="pi pi-exclamation-circle margin-dialog-message__icon" aria-hidden="true"></i>
    <span>{{ message }}</span>
</p>
